import React, { createContext } from 'react';
import { useLazyQuery, useApolloClient } from 'react-apollo';
import GET_ORGS_BASIC_DETAILS from '../../GraphQl/Queries/GET_ORGS_BASIC_DETAILS';

const OrgContext = createContext();

export const OrgProvider = ({ children }) => {
  const client = useApolloClient();
  const [
    fetchBasicOrgsDetails,
    { data: basicOrgsDetails, loading: basicOrgsDetailsLoading, error },
  ] = useLazyQuery(GET_ORGS_BASIC_DETAILS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  // Independent instance for the task form's Channel Partner/Advertiser/Assignee
  // fields. The form must NOT share result state with fetchBasicOrgsDetails: the
  // task board's advertiser filter reads that one, so the create-task modal's org
  // fetches were overwriting the filter's options (last fetch wins).
  const [
    fetchFormOrgsDetails,
    { data: formOrgsDetails, loading: formOrgsDetailsLoading, error: formOrgsError },
  ] = useLazyQuery(GET_ORGS_BASIC_DETAILS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  const queryOrgs = async (variables) => {
    const result = await client.query({
      query: GET_ORGS_BASIC_DETAILS,
      variables,
    });
    return result.data;
  };

  return (
    <OrgContext.Provider
      value={{
        fetchBasicOrgsDetails,
        queryOrgs,
        basicOrgsDetails: (basicOrgsDetails && basicOrgsDetails.orgs) || [],
        basicOrgsDetailsLoading,
        error,
        fetchFormOrgsDetails,
        formOrgsDetails: (formOrgsDetails && formOrgsDetails.orgs) || [],
        formOrgsDetailsLoading,
        formOrgsError,
      }}
    >
      {children}
    </OrgContext.Provider>
  );
};

export default OrgContext;
